var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonenumberDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160688",
    "data-name": "Group 160688",
    transform: "translate(-505.283 -159.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160604",
    "data-name": "Group 160604",
    transform: "translate(506.033 160)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 0.505,
    cy: 0.505,
    rx: 0.505,
    ry: 0.505,
    transform: "translate(3.644 13.636)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone1",
    d: "M7.677,17.318a13.765,13.765,0,0,0,8.076,2.6h2.079a2.077,2.077,0,0,0,2.079-2.08h0V16.575a1.042,1.042,0,0,0-.787-1.009l-4.086-1.018a1.047,1.047,0,0,0-1.079.381l-.893,1.195a.977.977,0,0,1-1.114.354A11.107,11.107,0,0,1,5.36,9.885.974.974,0,0,1,5.713,8.77l1.194-.894a1.023,1.023,0,0,0,.38-1.08L6.262,2.708A1.041,1.041,0,0,0,5.253,1.92H3.989A2.077,2.077,0,0,0,1.91,4h0v2.08a13.766,13.766,0,0,0,2.9,8.487",
    transform: "translate(-1.91 -1.92)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonenumberDarkIcon);
export default __webpack_public_path__ + "static/media/phonenumber-dark-icon.4a619729312736845f501347634b4b8f.svg";
export { ForwardRef as ReactComponent };